import { Icons } from "assets/icons";
import React from "react";
import { useTranslation } from "react-i18next";

const NoPermission = () => {
  const { t } = useTranslation();
  const { noPermission } = Icons || {};
  return (
    <div className="no_permission">
      <img src={noPermission} width={120} height={120} />
      <div>
        <h2>{t("Access Denied")}</h2>
        <p>{t("You don't have permission to access this page.")}</p>
        <p>{t("Please contact your administrator for access.")}</p>
      </div>
    </div>
  );
};

export default NoPermission;
